import { success } from "./../../../../shared/constants/success";
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AuthService } from "src/app/shared/services/auth.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { ServiceRequestService } from "../../service-request.service";
import { Subscription } from "rxjs";
import { Agent } from "src/app/shared/models/agent.model";
import { Helper } from "src/app/shared/helpers/helper";
import { ServiceRequest } from "src/app/shared/models/service-request.model";
import { Alert } from "src/app/shared/class/Alert";
import * as _ from "lodash";

@Component({
  selector: "app-service-request-add-agent",
  templateUrl: "./service-request-add-agent.component.html",
  styleUrls: ["./service-request-add-agent.component.scss"],
})
export class ServiceRequestAddAgentComponent implements OnInit {
  goback = "../list";
  queryParams: any = {};
  associateAgentForm: FormGroup;
  subscription = new Subscription();

  serviceRequests: ServiceRequest[] = [];
  agents: Agent[] = [];

  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private serviceRequestService: ServiceRequestService,
    private fb: FormBuilder,
    private router: Router
  ) {}

  async ngOnInit() {
    this.route.queryParams.subscribe(
      (params: any) => (this.queryParams = params)
    );

    this.associateAgentForm = this.fb.group({
      scheduleId: this.fb.control(null, Validators.required),
      agentId: this.fb.control(null, Validators.required),
    });
    this.spinner.show();
    await this.loadServiceRequests();
    await this.loadAgents();
    this.spinner.hide();
  }

  async loadAgents() {
    try {
      const data: any = await this.serviceRequestService.getAgents();
      this.agents =
        data.status === undefined ? Agent.orderAgentByName(data) : [];
    } catch (error) {
      console.error(error);
    }
  }

  async onSubmit() {
    if (this.associateAgentForm.valid) {
      this.spinner.show();

      this.subscription.add(
        this.serviceRequestService
          .updateServiceRequestAgent(
            this.associateAgentForm.get("agentId").value,
            this.associateAgentForm.get("scheduleId").value
          )
          .subscribe(
            () => {
              this.spinner.hide();
              Alert.success(Alert.getMessage().success.save);
            },
            (error) => {
              if (error.status === 200 || error.status === 201) {
                this.spinner.hide();
                Alert.success(Alert.getMessage().success.save).then(
                  async () => {
                    this.spinner.show("mailSpinner");

                    const emailSended = await this.serviceRequestService.sendAgentEmail(
                      this.associateAgentForm.get("agentId").value,
                      this.associateAgentForm.get("scheduleId").value
                    );

                    if (!_.isEmpty(emailSended.error)) {
                      this.spinner.hide("mailSpinner");
                      Alert.warning(Alert.getMessage().errors.sendEmail).then(
                        () => {
                          this.router.navigate(["../serviceRequest/list"]);
                        }
                      );
                    } else {
                      this.spinner.hide("mailSpinner");
                      Alert.success(Alert.getMessage().success.sendEmail).then(
                        () => {
                          this.router.navigate(["../serviceRequest/list"]);
                        }
                      );
                    }
                  }
                );
              } else {
                this.spinner.hide();
                Helper.handleError(error);
              }
            }
          )
      );
    }
  }

  async loadServiceRequests() {
    try {
      const data: any = await this.serviceRequestService.getSchedules(
        "agent=null"
      );
      this.serviceRequests = data.status === undefined ? data : [];
      this.serviceRequests = ServiceRequest.orderByDate(
        this.serviceRequests,
        "desc"
      );
    } catch (error) {
      console.error(error);
    }
  }
}
